import type { Maybe } from '@adornis/base/utilTypes.js';
import type { UserWithPermissionFields } from '../../permissions/UserWithPermissionFields.js';
import { ALL_FAMILY_LINKS, FAMILY_LINK_FIELDS, type FamilyLink } from './FamilyLink.js';

/** Whether `parent` holds `child` through one of `links` - by default as Sorgeberechtigter or as Spender. */
export function isParentOf(
  parent: Maybe<Pick<UserWithPermissionFields, '_id' | 'sorgeberechtigteKinderIDs' | 'spendenKinderIDs'>>,
  child: Maybe<Pick<UserWithPermissionFields, '_id'>>,
  links: FamilyLink[] = ALL_FAMILY_LINKS,
): boolean {
  if (!parent?._id || !child?._id) return false;
  return links.some(link => parent[FAMILY_LINK_FIELDS[link]]?.includes(child._id) ?? false);
}
